exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles-cssmodule-container-3RcB0{container-type:inline-size;position:relative;margin:0;width:auto;border-radius:var(--card-border-radius);padding:var(--card-padding);display:flex;flex-direction:column;border:var(--border);row-gap:var(--card-row-gap);color:var(--font-color);background-color:var(--background-color)}.styles-cssmodule-cardHeader-8JR8O{min-height:40px;display:flex;background-color:var(--background-color);align-items:center;justify-content:space-between;flex-wrap:wrap;gap:7px;margin:0;padding:0;border:none}.styles-cssmodule-cardTitle-3GZuK{font-size:1.3rem!important;display:flex;color:var(--color-sky-gray9);align-items:center;gap:7px;margin:0;line-height:1.5}.styles-cssmodule-divider-2UX9N{height:1px;background-color:var(--border-color);margin:0!important}", ""]);

// exports
exports.locals = {
	"container": "styles-cssmodule-container-3RcB0",
	"cardHeader": "styles-cssmodule-cardHeader-8JR8O",
	"cardTitle": "styles-cssmodule-cardTitle-3GZuK",
	"divider": "styles-cssmodule-divider-2UX9N"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]-[local]-[hash:base64:5]"}!./components/card/styles.cssmodule.css
// module id = 2530
// module chunks = 121